import { DateTimeFormat } from "~/components/date/DateTimeFormat.jsx";
import { $t } from "~/i18n.js";
import React from "react";

export const LastUpdated = ({ date_updated, updated_by = null, style={} }) => {
  if (!date_updated) return null;
  return (
    <p className="small gray" style={{ marginBottom: 6, ...style }}>
      {$t("Laatst bijgewerkt op")}:{" "}
      <DateTimeFormat
        date={date_updated}
        options={{
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }}
      />
      {updated_by ? `, ${$t("door")} ${updated_by}` : ""}
    </p>
  );
};
